import { WebchatOptions } from "../../Redux/reduxState";
import darkTheme from "../../../assets/themes/dark.json";
import lightTheme from "../../../assets/themes/light.json";
import legacyTheme from "../../../assets/themes/legacy.json";

export interface ThemeDefinition {
    id: string;
    displayName: string;
    options: Partial<WebchatOptions>;
}

export const themes: ThemeDefinition[] = [
    { id: 'legacy', displayName: 'Legacy', options: legacyTheme as Partial<WebchatOptions> },
    { id: 'light', displayName: 'Light', options: lightTheme as Partial<WebchatOptions> },
    { id: 'dark', displayName: 'Dark', options: darkTheme as Partial<WebchatOptions> },
];
